import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
`;

export const CustomerIDBadge = styled.div`
  color: #fff;
  text-align: center;
  font-family: Nunito, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  border-radius: 10px;
  background: linear-gradient(135deg, #fdc700 0%, #f0b100 100%);
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -2px rgba(0, 0, 0, 0.1);
  padding: 8px 16px;
  display: inline-block;
`;

export const DateTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.5rem;
  font-size: 12px;
  font-weight: bold;
  max-width: 200px;
  border-radius: 20px;
  background-color: #9747ff1a;
  color: #9747ff;
  cursor: pointer;
`;

export const Container = styled.div`
  padding: 20px 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media screen and (max-width: 1300px) {
    .table-main-container {
      display: none;
    }
  }

  @media screen and (min-width: 1300px) {
    .mobile-list-main-container {
      display: none;
    }
  }
`;

export const OfferCountBadge = styled.div`
  color: #2d6cdf;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: underline;
  text-align: center;
  cursor: pointer;
`;
